import { TrainingSessionWizardMutationInvalidator } from '../tokens/training-session-component.tokens';

/**
 * Returns a memoized mutation invalidator wired from a lazy module import.
 * Use in kiraah-app shell providers to avoid static feature imports in app.config.ts.
 */
export function createMemoizedMutationInvalidator(
  importer: () => Promise<TrainingSessionWizardMutationInvalidator>
): TrainingSessionWizardMutationInvalidator {
  let cachedInvalidator: TrainingSessionWizardMutationInvalidator | null = null;
  let loading: Promise<void> | null = null;

  const ensureLoaded = (): Promise<void> => {
    if (cachedInvalidator) {
      return Promise.resolve();
    }

    loading ??= importer().then((invalidator) => {
      cachedInvalidator = invalidator;
    });

    return loading;
  };

  return (coordinator, uid, mutationKind, stepKey) => {
    if (cachedInvalidator) {
      cachedInvalidator(coordinator, uid, mutationKind, stepKey);
      return;
    }

    void ensureLoaded().then(() => cachedInvalidator!(coordinator, uid, mutationKind, stepKey));
  };
}
